(function () {
  'use strict';

  angular
    .module('MktzapApp.Factories')
    .factory('LangService', LangService);

  LangService.$inject = ['$resource'];

  function LangService ($resource) {
    return $resource('', {}, {
      getSesameFirstAccessLabels: { url: frontUrl + '/sesame-fa-lang', method: 'POST', params: {}, isArray: false },
      getLoginLabels: { url: frontUrl + '/login-lang', method: 'POST', params: {}, isArray: false },
      getPageLabels: { url: frontUrl + '/page-lang', method: 'POST', params: {}, isArray: false },
      getLangs: { url: apiUrl + '/get-langs', method: 'GET', params: {}, isArray: false },
      saveLang: { url: apiUrl + '/save-lang', method: 'POST', params: {}, isArray: false }
    });
  }
})();
